/**
 * Request model for POST /task/v1/tasks (new Create Task modal).
 * Matches backend CreateTaskRequest. Do not modify existing task save types.
 */

/** Task priority: 1=Low, 2=Normal, 3=High */
export enum TaskPriorityV1 {
  Low = 1,
  Normal = 2,
  High = 3,
}

/**
 * Root task category enum for v1 API.
 * Possible values per backend: FileRequest (1), General (2), CueNotes (3), PPW (4),
 * HousingCommunication (5), ApprovalNeeded (6), Compliance (7), ExpiringLicense (8),
 * ExtensionRequest (9), LatexAllergy (10), LicensureVerification (11), MALocalRestriction (12),
 * MissingTimeCard (13), PayrollIssue (14), Audit (15), CLTQReview (16), ExamRemediation (17),
 * ExpiringDocuments (18), NameChange (19), Referencing (20), QuickBook (21), PendingDocuments (22),
 * CompetitiveOnboarding (23), SpecialtyMismatch (24), WebCueNotes (25), CCNewBooking (26),
 * CCExtension (27), CCModification (28), OGPConfirmedStart (29), TimeIntegrity (30).
 */
export enum RootTaskCategory {
  FileRequest = 1,
  General = 2,
  CueNotes = 3,
  PPW = 4,
  HousingCommunication = 5,
  ApprovalNeeded = 6,
  Compliance = 7,
  ExpiringLicense = 8,
  ExtensionRequest = 9,
  LatexAllergy = 10,
  LicensureVerification = 11,
  MALocalRestriction = 12,
  MissingTimeCard = 13,
  PayrollIssue = 14,
  Audit = 15,
  CLTQReview = 16,
  ExamRemediation = 17,
  ExpiringDocuments = 18,
  NameChange = 19,
  Referencing = 20,
  QuickBook = 21,
  PendingDocuments = 22,
  CompetitiveOnboarding = 23,
  SpecialtyMismatch = 24,
  WebCueNotes = 25,
  CCNewBooking = 26,
  CCExtension = 27,
  CCModification = 28,
  OGPConfirmedStart = 29,
  TimeIntegrity = 30,
}

export interface ICreateTaskRequest {
  travelerId?: number | null;
  placementId?: number | null;
  orderId?: number | null;
  facilityId?: number | null;
  originalTaskId?: number | null;
  dueDate: string; // ISO date-time
  contractAffiliateId?: number | null;
  sendOnBehalfOfEmployeeId?: number | null;
  toEmployeeIds: number[];
  ccEmployeeIds?: number[];
  category: RootTaskCategory;
  priority: TaskPriorityV1;
  subject: string;
  message?: string;
  isFollowUp: boolean;
  isOptionApproval: boolean;
  isFlagged: boolean;
  followUpDate?: string | null; // Required when isFollowUp is true; ISO date
}
